import { useEffect, useState } from 'react';
import './App.css';
import Background from './Background';
import Home from './Home';
import About from './About';
import { Privacy, Terms, ContentPolicy } from './Legal';

function routeFromHash() {
  const h = (window.location.hash || '').replace(/^#\/?/, '').toLowerCase();
  if (h === 'about') return 'about';
  if (h === 'privacy') return 'privacy';
  if (h === 'terms') return 'terms';
  if (h === 'content') return 'content';
  return 'home';
}

export default function App() {
  const [route, setRoute] = useState(routeFromHash);

  useEffect(() => {
    const onHash = () => setRoute(routeFromHash());
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [route]);

  const navigate = (to) => {
    window.location.hash = to === 'home' ? '' : '/' + to;
    setRoute(to);
  };

  return (
    <div className="app-root">
      <Background />
      <div className="app-content">
        {route === 'about' && <About onNavigate={navigate} />}
        {route === 'privacy' && <Privacy onNavigate={navigate} />}
        {route === 'terms' && <Terms onNavigate={navigate} />}
        {route === 'content' && <ContentPolicy onNavigate={navigate} />}
        {route === 'home' && <Home onNavigate={navigate} />}
      </div>
    </div>
  );
}
